export const parseHeightString = (
  heightStr: string,
): { value: number; unit: "cm" | "inch" } => {
  // Handle feet/inches format (e.g. "6ft", "6 ft", "72in", "72 in", "6ft2in", "6ft 2in", "6 ft 2 in")
  const ftInMatch = heightStr.match(
    /^(\d+)\s*?f(?:ee)?t\s*(?: ?(\d+)\s*?in(?:ches)?)?$|^(\d+)\s*?in(?:ches)?$/,
  );
  if (ftInMatch) {
    const feet = Number(ftInMatch[1] || 0);
    const inches = Number(ftInMatch[2] || ftInMatch[3] || 0);
    return { value: feet * 12 + inches, unit: "inch" };
  }

  // Handle meters/cm format (e.g. "1m", "180cm", "1m80cm", "1m 80cm")
  const mCmMatch = heightStr.match(
    /^(\d+)\s*?m(?: ?(\d+)\s*?cm)?$|^(\d+)\s*?cm$/,
  );
  if (mCmMatch) {
    const meters = Number(mCmMatch[1] || 0);
    const centimeters = Number(mCmMatch[2] || mCmMatch[3] || 0);
    return {
      value: meters * 100 + centimeters,
      unit: "cm",
    };
  }

  throw new Error("Invalid height format");
};

export const formatHeight = (
  value: number,
  unit: "cm" | "inch" | "in",
): string => {
  if (unit === "inch" || unit === "in") {
    const feet = Math.floor(value / 12);
    // Currently the backend always returns in inches; however, if the height was saved in
    // metric, the value will be a decimal. Thus, round to nearest hundredth.
    const inches = Math.round((value % 12) * 100) / 100;
    return inches === 0 ? `${feet} ft` : `${feet} ft ${inches} in`;
  }
  const meters = Math.floor(value / 100);
  const cm = value % 100;
  return cm === 0 ? `${meters} m` : `${meters} m ${cm} cm`;
};
